<template>
  <div class="field-map" style="position: absolute; z-index:10; width: 95%; height: 90%;">
    <v-btn
      id="hideMapBtn"
      icon
      color="white"
      class="go-back-btn"
      @click="hideMap"
    >
      <v-icon x-large>arrow_forward_ios</v-icon>
    </v-btn>
    <div class="google-map" ref="mapName"/>
  </div>
</template>

<script>
const closeIconFile = require('../../../assets/icons/close.png')
const mapMarkerIconFile = require('../../../assets/icons/mapMarker.png')
export default {
  name: 'fieldMap',
  props: {
    fieldMapSelection: {
      type: Boolean,
      required: true
    },
    fieldData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      positionMarkers: []
    }
  },
  mounted () {
    this.loadMap()
  },
  methods: {
    hideMap () {
      this.$emit('update:fieldMapSelection', !this.fieldMapSelection)
    },
    zoomControl (controlDiv, map) {
      const zoomControl = document.createElement('div')
      const zoomInUI = document.createElement('div')

      zoomInUI.style.width = '42px'
      zoomInUI.style.height = '42px'
      zoomInUI.style.backgroundColor = '#fff'
      zoomInUI.style.border = '2px solid #fff'
      zoomInUI.style.borderRadius = '3px'
      zoomInUI.style.boxShadow = '0px 4px 4px rgba(0, 0, 0, 0.25)'
      zoomInUI.style.cursor = 'pointer'
      zoomInUI.style.marginTop = '8px'
      zoomInUI.style.marginBottom = '20px'
      zoomInUI.style.textAlign = 'center'
      zoomInUI.style.borderRadius = '50%'
      zoomControl.appendChild(zoomInUI)

      const zoomInText = document.createElement('div')

      zoomInText.style.color = '#000000'
      zoomInText.style.fontFamily = 'Roboto,Arial,sans-serif'
      zoomInText.style.fontSize = '30px'
      zoomInText.style.lineHeight = '38px'
      zoomInText.style.paddingLeft = '5px'
      zoomInText.style.paddingRight = '5px'
      zoomInText.innerHTML = '+'
      zoomInUI.appendChild(zoomInText)

      zoomInUI.addEventListener('click', () => {
        map.setZoom(map.zoom + 1)
      })

      const zoomOutUI = document.createElement('div')

      zoomOutUI.style.width = '42px'
      zoomOutUI.style.height = '42px'
      zoomOutUI.style.backgroundColor = '#fff'
      zoomOutUI.style.border = '2px solid #fff'
      zoomOutUI.style.borderRadius = '3px'
      zoomOutUI.style.boxShadow = '0px 4px 4px rgba(0, 0, 0, 0.25)'
      zoomOutUI.style.cursor = 'pointer'
      zoomOutUI.style.marginTop = '8px'
      zoomOutUI.style.marginBottom = '22px'
      zoomOutUI.style.textAlign = 'center'
      zoomOutUI.style.borderRadius = '50%'
      zoomControl.appendChild(zoomOutUI)

      const zoomOutText = document.createElement('div')
      zoomOutText.style.color = '#000000'
      zoomOutText.style.fontFamily = 'Roboto,Arial,sans-serif'
      zoomOutText.style.fontSize = '30px'
      zoomOutText.style.lineHeight = '38px'
      zoomOutText.style.paddingLeft = '5px'
      zoomOutText.style.paddingRight = '5px'
      zoomOutText.innerHTML = '-'
      zoomOutUI.appendChild(zoomOutText)
      zoomOutUI.addEventListener('click', () => {
        map.setZoom(map.zoom - 1)
      })

      controlDiv.appendChild(zoomControl)
    },
    dataConfirmationDiv (controlDiv) {
      const dataConfirmationDiv = document.createElement('div')
      dataConfirmationDiv.id = 'dataConfirmationDiv'
      dataConfirmationDiv.style.textAlign = 'left'
      dataConfirmationDiv.style.alignSelf = 'center'
      dataConfirmationDiv.style.marginRight = '30px'
      const confirmBtn = document.createElement('input')
      confirmBtn.id = 'confirmBtn'
      confirmBtn.type = 'button'
      confirmBtn.style.background = this.fieldData.gates.length ? '#0098E1' : '#77C5EB'
      confirmBtn.style.boxShadow = '0px 4px 4px rgba(0, 152, 225, 0.25)'
      confirmBtn.style.borderRadius = '5px'
      confirmBtn.style.justifyContent = 'center'
      confirmBtn.style.alignItems = 'center'
      confirmBtn.style.paddingLeft = '25px'
      confirmBtn.style.paddingRight = '25px'
      confirmBtn.style.paddingTop = '8px'
      confirmBtn.style.paddingBottom = '8px'
      confirmBtn.style.fontFamily = 'Source Sans 3'
      confirmBtn.style.fontStyle = 'normal'
      confirmBtn.style.fontWeight = 400
      confirmBtn.style.fontSize = '22px'
      confirmBtn.style.lineHeight = '28px'
      confirmBtn.style.color = '#FFFFFF'
      confirmBtn.disabled = !(this.fieldData.gates.length)

      confirmBtn.value = this.$t('FieldMap.confirmData')
      confirmBtn.addEventListener('click', () => {
        const gates = []
        this.positionMarkers.forEach(position => {
          const newGate = {
            latitude: position.marker.getPosition().lat(),
            longitude: position.marker.getPosition().lng()
          }
          gates.push(newGate)
        })
        const newFieldData = {...this.fieldData}
        newFieldData.gates = gates
        this.$emit('update-field-data', newFieldData)
        document.querySelector('#dataConfirmationDiv').style.display = 'none'
        document.querySelector('#hideMapBtn').click()
      })
      dataConfirmationDiv.appendChild(confirmBtn)
      controlDiv.appendChild(dataConfirmationDiv)
    },
    addNewPosition (latitude, longitude, map) {
      let newPosition = {
        // eslint-disable-next-line
        marker: new google.maps.Marker({
          position: {lat: latitude, lng: longitude},
          map,
          icon: mapMarkerIconFile,
          zIndex: 2
        })
      }
      // eslint-disable-next-line
      newPosition.deleteBtn = new google.maps.Marker({
        position: {lat: newPosition.marker.getPosition().lat() + 0.001, lng: newPosition.marker.getPosition().lng() + 0.0004},
        map,
        icon: closeIconFile,
        zIndex: 3
      })
      newPosition.deleteBtn.addListener('click', () => {
        newPosition.deleteBtn.setMap(null)
        newPosition.deleteBtn = null
        const positionIndex = this.positionMarkers.findIndex(elem =>
          elem.marker.getPosition().lat() === newPosition.marker.getPosition().lat() &&
          elem.marker.getPosition().lng() === newPosition.marker.getPosition().lng()
        )
        newPosition.marker.setMap(null)
        newPosition.marker = null
        this.positionMarkers.splice(positionIndex, 1)
        if (!this.positionMarkers.length) {
          const confirmBtn = document.getElementById('confirmBtn')
          confirmBtn.style.background = '#77C5EB'
          confirmBtn.disabled = true
        }
      })
      const confirmBtn = document.getElementById('confirmBtn')
      if (confirmBtn) {
        confirmBtn.style.background = '#0098E1'
        confirmBtn.disabled = false
      }
      this.positionMarkers.push(newPosition)
    },
    addGate (event, map) {
      this.addNewPosition(event.latLng.lat(), event.latLng.lng(), map)
    },
    initializeGates (map) {
      this.fieldData.gates.forEach(gate => {
        this.addNewPosition(gate.latitude, gate.longitude, map, true)
      })
    },
    loadMap () {
      const element = this.$refs.mapName
      let zoom = 5
      let center = {lat: -35.026974, lng: -64.466206}
      const options = {
        zoom,
        center,
        // eslint-disable-next-line
        mapTypeId: google.maps.MapTypeId.HYBRID,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      }
      // eslint-disable-next-line
      const map = new google.maps.Map(element, options)

      const gradientDiv = document.createElement('div')
      gradientDiv.style.height = '130px'
      gradientDiv.style.width = '100%'
      gradientDiv.style.background = 'linear-gradient(180deg, #00202F 9.92%, rgba(0, 32, 47, 0) 100%)'
      // eslint-disable-next-line
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(gradientDiv)

      const zoomControlDiv = document.createElement('div')
      zoomControlDiv.style.marginRight = '40px'
      zoomControlDiv.style.marginBottom = '10px'
      zoomControlDiv.style.display = 'flex'
      this.dataConfirmationDiv(zoomControlDiv, map)
      this.zoomControl(zoomControlDiv, map)
      // eslint-disable-next-line
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv)

      const titleDiv = document.createElement('div')
      titleDiv.style.marginTop = '20px'
      titleDiv.style.width = '50%'
      const titleText = document.createElement('p')
      titleText.id = 'titleText'
      titleText.innerHTML = this.$t('FieldMap.markGates')
      titleText.style.fontFamily = 'Source Sans 3'
      titleText.style.fontStyle = 'normal'
      titleText.style.fontWeight = '700'
      titleText.style.fontSize = '36px'
      titleText.style.lineHeight = '45px'
      titleText.style.textAlign = 'center'
      titleText.style.color = '#FFFFFF'
      titleDiv.appendChild(titleText)
      // eslint-disable-next-line
      map.controls[google.maps.ControlPosition.TOP_CENTER].push(titleDiv)

      map.addListener('click', (evt) => { this.addGate(evt, map) })
      if (this.fieldData.gates.length) {
        this.initializeGates(map)
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// FieldMap.vue?f09a95da